export default __webpack_public_path__ + "static/media/feature-tool_tab_1.fe16049d31536542aed21c38e0174030.svg";